import { isToday, isTomorrow, parseISO } from "date-fns";
import { useEffect } from "react";
import FullScreenLayout from "../../../components/FullScreenLayout";
import { AdminAppointmentWidget, NewAppointmentWidget } from "../../../pages/platform/components/NewAppointmentWidget";
import { daysOfWeek, months } from "../../../utils/Constants";
import { useAppointments } from "../../../utils/context/AppointmentsContext";
import { useAuth } from "../../../utils/context/AuthContext";
import { useUserData } from "../../../utils/context/UserDataContext";
import { ExpertRole } from "../../../utils/Enums";

const Appointments = () => {
  const { auth } = useAuth()
  const idToken = auth.idToken
  const role = auth.role
  const { userData } = useUserData()
  const email = userData.email
  const { appointmentsState } = useAppointments()
  const allAppointments = appointmentsState.allAppointments
  const allFutureActiveAppointments = appointmentsState.allFutureActiveAppointments
  const allMyFutureActiveAppointments = role === ExpertRole.Admin 
    ? allFutureActiveAppointments 
    : allFutureActiveAppointments?.filter(app => 
      app.expert_email === email || app.expert_email === "dr.gentilesalvatore@gmail.com"
    )

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const dayOfWeek = daysOfWeek[today.getDay()];
  const dayOfWeekTomorrow = daysOfWeek[tomorrow.getDay()];
  const dayOfMonth = today.getDate();
  const dayOfMonthTomorrow = tomorrow.getDate();
  const month = months[today.getMonth()];
  const monthTomorrow = months[tomorrow.getMonth()];

  useEffect(() => {
    // if (role !== ExpertRole.Admin) {
    //   return
    // }
    // const fetchAppointments = async () => {
    //   const appointments = await getAllAppointments(idToken!)
    //   console.log(appointments)
    // }
    // fetchAppointments()
  }, [])

  // ********************************************************************************

  if (!allMyFutureActiveAppointments) {
    return (
      <FullScreenLayout title="Appuntamenti">
        <div className="font-medium text-[20px] leading-[33px]">
          C'è stato un errore nel recuperare gli appuntamenti. Ti chiediamo di riprovare.
        </div>
      </FullScreenLayout>
    )
  }

  const allTodayAppointments = allMyFutureActiveAppointments.filter(app => {
    const appointmentDate = parseISO(app.date);

    return isToday(appointmentDate)
  })

  const allTomorrowAppointments = allMyFutureActiveAppointments.filter(app => {
    const appointmentDate = parseISO(app.date);

    return isTomorrow(appointmentDate)
  })

  const allIncomingAppointments = allMyFutureActiveAppointments.filter(app => {
    const appointmentDate = parseISO(app.date);

    return !isToday(appointmentDate) && !isTomorrow(appointmentDate)
  })

  // ********************************************************************************

  return (
    <FullScreenLayout title="Appuntamenti">
      <div className='w-full flex flex-col space-y-6'>
        {
          allTodayAppointments.length > 0 &&
          <div className="space-y-4">
            <div className="font-bold text-[20px] leading-[33px]">
              Oggi | <span className="font-medium">{dayOfWeek} {dayOfMonth} {month}</span>
            </div>
            <div className="space-y-4">
              {
                allTodayAppointments.map((app, index) =>
                  role === ExpertRole.Admin ? (
                    <AdminAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  ) : (
                    <NewAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  )
                )
              }
            </div>
          </div>
        }
        {
          allTomorrowAppointments.length > 0 &&
          <div className="space-y-4">
            <div className="font-bold text-[20px] leading-[33px]">
              Domani | <span className="font-medium">{dayOfWeekTomorrow} {dayOfMonthTomorrow} {monthTomorrow}</span>
            </div>
            <div className="space-y-4">
              {
                allTomorrowAppointments.map((app, index) =>
                  role === ExpertRole.Admin ? (
                    <AdminAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  ) : (
                    <NewAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  )
                )
              }
            </div>
          </div>
        }
        {
          allIncomingAppointments.length > 0 &&
          <div className="space-y-4">
            <div className="font-bold text-[20px] leading-[33px]">
              In arrivo
            </div>
            <div className="space-y-4">
              {
                allIncomingAppointments.map((app, index) =>
                  role === ExpertRole.Admin ? (
                    <AdminAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  ) : (
                    <NewAppointmentWidget
                      key={index}
                      appointment={app}
                    />
                  )
                )
              }
            </div>
          </div>
        }
      </div>
    </FullScreenLayout>
  )
}

export default Appointments
